var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-backtop',{staticClass:"custom-backtop",attrs:{"visibility-height":_vm.visibilityHeight,"right":_vm.right,"bottom":_vm.bottom}})
}
var staticRenderFns = []

export { render, staticRenderFns }